import { render, staticRenderFns } from "./LimitTag.vue?vue&type=template&id=16b5f12c&scoped=true&"
import script from "./LimitTag.vue?vue&type=script&lang=js&"
export * from "./LimitTag.vue?vue&type=script&lang=js&"
import style0 from "./LimitTag.vue?vue&type=style&index=0&id=16b5f12c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b5f12c",
  null
  
)

export default component.exports